/*
 * EILIKO page behaviour — templates/product.elikotmp.json only (loaded by sections/eiliko-page.liquid).
 * Independent of the motion setting. Never changes cart logic: bundle shortcuts only scroll and
 * press the bundle card's own [data-pick] button; the digit normaliser only rewrites display text;
 * the stepper states only add display classes after the bundle's own handlers have run.
 */
(function () {
  'use strict';

  if (window.EilikoPage) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* ---------------------------------------------------------------
     English digits for every visible number (display text only)
     --------------------------------------------------------------- */
  var ARABIC_DIGITS = /[٠-٩۰-۹]/g;

  function toLatin(text) {
    return text.replace(ARABIC_DIGITS, function (d) {
      var code = d.charCodeAt(0);
      return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
    });
  }

  function normaliseDigits(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (ARABIC_DIGITS.test(node.nodeValue)) node.nodeValue = toLatin(node.nodeValue);
      ARABIC_DIGITS.lastIndex = 0;
    }
  }

  function watchDigits(root) {
    if (!root || root.dataset.eikDigits) return;
    root.dataset.eikDigits = '1';
    normaliseDigits(root);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') {
          var text = record.target.nodeValue;
          if (ARABIC_DIGITS.test(text)) record.target.nodeValue = toLatin(text);
          ARABIC_DIGITS.lastIndex = 0;
        } else {
          record.addedNodes.forEach(function (added) {
            if (added.nodeType === 3) {
              if (ARABIC_DIGITS.test(added.nodeValue)) added.nodeValue = toLatin(added.nodeValue);
              ARABIC_DIGITS.lastIndex = 0;
            } else if (added.nodeType === 1) {
              normaliseDigits(added);
            }
          });
        }
      });
    }).observe(root, { subtree: true, childList: true, characterData: true });
  }

  /* ---------------------------------------------------------------
     Deferred animated media (data-eiliko-src)
     --------------------------------------------------------------- */
  function loadDeferred(img) {
    if (img && img.dataset.eilikoSrc && !img.getAttribute('src')) {
      img.setAttribute('src', img.dataset.eilikoSrc);
    }
  }

  // Loads the deferred images of `selector` inside `container` once it is within 600px.
  function deferWhenNear(container, selector) {
    if (!container.querySelector(selector)) return;
    function load() {
      all(container, selector).forEach(loadDeferred);
    }
    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      load();
      io.disconnect();
    }, { rootMargin: '600px 0px' });
    io.observe(container);
  }

  /* ---------------------------------------------------------------
     Videos: muted previews play only while on screen
     --------------------------------------------------------------- */
  function initVideo(card) {
    if (card.dataset.eikReady) return;
    card.dataset.eikReady = '1';

    var video = card.querySelector('[data-eik-video]');
    var toggle = card.querySelector('[data-eik-video-toggle]');
    if (!video) return;

    var userPaused = REDUCED.matches;
    var onScreen = false;

    function setPlaying(playing) {
      card.classList.toggle('is-playing', playing);
      if (toggle) toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
    }

    function play() {
      if (video.preload !== 'auto') video.preload = 'auto';
      var played = video.play();
      if (played && played.catch) {
        played.catch(function () { setPlaying(false); });
      }
    }

    function sync() {
      if (onScreen && !userPaused) play();
      else if (!video.paused) video.pause();
    }

    video.addEventListener('play', function () { setPlaying(true); });
    video.addEventListener('pause', function () { setPlaying(false); });
    // The poster stays in place when the clip cannot be loaded.
    video.addEventListener('error', function () { card.classList.add('is-failed'); }, true);
    var source = video.querySelector('source');
    if (source) source.addEventListener('error', function () { card.classList.add('is-failed'); });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause();
        else play();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { onScreen = entry.isIntersecting; });
      sync();
    }, { threshold: 0.35 }).observe(card);
  }

  /* ---------------------------------------------------------------
     Bundle shortcuts
     --------------------------------------------------------------- */
  function bundleTarget() {
    return document.getElementById('eiliko-buy') || document.querySelector('.iqe');
  }

  function scrollToBundle(target) {
    target = target || bundleTarget();
    if (!target) return;
    target.scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'start' });
  }

  function onPick(event) {
    var trigger = event.target.closest('[data-eiliko-pick]');
    if (!trigger) return;
    var card = document.querySelector('.iqe [data-b="' + trigger.dataset.eilikoPick + '"]');
    if (!card) return;
    event.preventDefault();
    var pick = card.querySelector('[data-pick]');
    // The bundle's own handler decides whether the card can be selected.
    if (pick && card.dataset.ok === '1') pick.click();
    scrollToBundle(card);
  }

  /* ---------------------------------------------------------------
     Quantity stepper display states (read-only on the bundle)
     --------------------------------------------------------------- */
  function syncSteppers() {
    all(document, '.iqe [data-r]').forEach(function (row) {
      var input = row.querySelector('[data-n]');
      var minus = row.querySelector('[data-minus]');
      if (!input || !minus) return;
      var value = parseInt(toLatin(String(input.value)), 10) || 0;
      minus.classList.toggle('eik-qty-min', value <= 0);
      row.classList.toggle('is-active-qty', value > 0);
    });
  }

  function initSteppers() {
    if (!document.querySelector('.iqe [data-r]')) return;
    syncSteppers();
    // After the bundle's own click handlers have updated the inputs.
    document.addEventListener('click', function (event) {
      if (event.target.closest('.iqe')) setTimeout(syncSteppers, 0);
    });
  }

  /* ---------------------------------------------------------------
     Mobile sticky bar
     --------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-eiliko-sticky]');
    var bundle = document.querySelector('.iqe');
    if (!bar || !bundle || !('IntersectionObserver' in window)) return;

    var final = document.querySelector('[data-eik-scene="final"]');
    var scheduled = false;

    function update() {
      scheduled = false;
      var rect = bundle.getBoundingClientRect();
      var finalRect = final && final.getBoundingClientRect();
      var finalVisible = finalRect && finalRect.top < window.innerHeight && finalRect.bottom > 0;
      var show = window.matchMedia('(max-width: 749px)').matches && rect.bottom <= 0 && !finalVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    }
    new IntersectionObserver(schedule).observe(bundle);
    if (final) new IntersectionObserver(schedule).observe(final);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    window.addEventListener('hashchange', schedule);
    window.addEventListener('popstate', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(bundle);
    update();
  }


  /* ---------------------------------------------------------------
     SpinKit wardrobe: set switch and outfit (frame cell + stand)
     --------------------------------------------------------------- */
  function initWardrobe(root) {
    if (root.dataset.eikReady) return;
    root.dataset.eikReady = '1';
    root.classList.add('is-enhanced');

    var tabs = all(root, '[data-eik-cfg-kit]');
    var panels = all(root, '[data-eik-cfg-panel]');
    var infos = all(root, '[data-eik-cfg-info]');

    // Input modality only: the selection routines below are unchanged.
    root.addEventListener('keydown', function () { root.setAttribute('data-eik-keyboard', ''); }, true);
    root.addEventListener('pointerdown', function () { root.removeAttribute('data-eik-keyboard'); }, true);
    root.addEventListener('click', function (event) {
      if (event.detail === 0) root.setAttribute('data-eik-keyboard', '');
    }, true);

    function selectOutfit(button) {
      var panel = button.closest('[data-eik-cfg-panel]');
      var key = button.dataset.eikOutfit;
      // The frame cell and its display stand share the key; both show the selection.
      all(panel, '[data-eik-outfit]').forEach(function (b) {
        var on = b.dataset.eikOutfit === key;
        b.classList.toggle('is-active', on);
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var info = root.querySelector('[data-eik-cfg-info="' + panel.dataset.eikCfgPanel + '"] [data-eik-cfg-look-label]');
      if (info) info.textContent = button.dataset.label;
    }

    function selectKit(index, focus) {
      var panel = panels[index];
      if (!panel) return;
      var id = panel.dataset.eikCfgPanel;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
      infos.forEach(function (info) { info.classList.toggle('is-active', info.dataset.eikCfgInfo === id); });
    }

    root.addEventListener('click', function (event) {
      var outfit = event.target.closest('[data-eik-outfit]');
      if (outfit) return selectOutfit(outfit);
      var tab = event.target.closest('[data-eik-cfg-kit]');
      if (tab) return selectKit(tabs.indexOf(tab));
    });

    tabs.forEach(function (tab, i) {
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.addEventListener('keydown', function (event) {
        var rtl = getComputedStyle(root).direction === 'rtl';
        var step = { ArrowLeft: rtl ? 1 : -1, ArrowRight: rtl ? -1 : 1 }[event.key];
        if (event.key === 'Home') selectKit(0, true);
        else if (event.key === 'End') selectKit(tabs.length - 1, true);
        else if (step) selectKit((i + step + tabs.length) % tabs.length, true);
        else return;
        event.preventDefault();
      });
    });
  }

  /* ---------------------------------------------------------------
     Bundle cards: native state/layout changes immediately; only the opening content fades in.
     No height measurement, animated padding, or delayed collapse. Keyboard changes are instant.
     --------------------------------------------------------------- */
  function initBundleMotion() {
    var cards = all(document, '.iqe .iqe-card');
    if (!cards.length || !('MutationObserver' in window) || !Element.prototype.animate) return;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var keyboard = false;
    var root = document.querySelector('.iqe');
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-pick]')) keyboard = event.detail === 0;
    }, true);

    function animateBody(card, opening) {
      var body = card.querySelector('.iqe-body');
      if (!body) return;
      if (body.eikAnim) body.eikAnim.cancel();
      if (!opening || REDUCED.matches || keyboard) return;
      var anim = body.animate([
        { opacity: 0, transform: 'translateY(4px)' },
        { opacity: 1, transform: 'none' }
      ], { duration: 200, easing: EASE });
      body.eikAnim = anim;
      anim.onfinish = anim.oncancel = function () {
        if (body.eikAnim === anim) body.eikAnim = null;
      };
    }

    cards.forEach(function (card) {
      var selected = card.classList.contains('is-selected');
      new MutationObserver(function () {
        var now = card.classList.contains('is-selected');
        if (now === selected) return;
        selected = now;
        animateBody(card, now);
      }).observe(card, { attributes: true, attributeFilter: ['class'] });
    });
    REDUCED.addEventListener('change', function () {
      if (!REDUCED.matches) return;
      cards.forEach(function (card) {
        var body = card.querySelector('.iqe-body');
        if (body && body.eikAnim) body.eikAnim.cancel();
      });
    });
  }

  /* ---------------------------------------------------------------
     Boot
     --------------------------------------------------------------- */
  function initLanguage(scope) {
    all(scope, '.eik, [data-eiliko-hero], [data-eiliko-sticky], section[id^="MainProduct-"]').forEach(function (el) {
      el.lang = 'ar';
      el.dir = 'rtl';
    });
    all(scope, '.eiliko-hero__name bdi, .eiliko-eyebrow bdi, .iqe-prod strong, .iqe-copy strong, .eik-dress__tab').forEach(function (el) {
      el.lang = 'en';
    });
  }

  // Reflect the existing bundle state; selection and quantity handlers remain untouched.
  function initBundleAccessibility() {
    var root = document.querySelector('.iqe');
    if (!root || root.dataset.eikAccessible) return;
    root.dataset.eikAccessible = '1';
    var prefix = root.id || 'eiliko-bundles';
    function sync() {
      all(root, '.iqe-card').forEach(function (card, index) {
        var head = card.querySelector('[data-pick]');
        var panel = card.querySelector('.iqe-body');
        if (!head || !panel) return;
        var selected = card.classList.contains('is-selected');
        head.id = prefix + '-choice-' + index;
        panel.id = prefix + '-panel-' + index;
        head.setAttribute('aria-controls', panel.id);
        head.setAttribute('aria-expanded', String(selected));
        head.setAttribute('aria-pressed', String(selected));
        head.setAttribute('aria-disabled', String(card.dataset.ok !== '1'));
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-labelledby', head.id);
        panel.inert = !selected;
        all(card, '[data-r]').forEach(function (row) {
          var title = row.dataset.title || row.dataset.label || '';
          var minus = row.querySelector('[data-minus]');
          var plus = row.querySelector('[data-plus]');
          var input = row.querySelector('[data-n]');
          if (minus) minus.setAttribute('aria-label', 'تقليل كمية ' + title);
          if (plus) plus.setAttribute('aria-label', 'زيادة كمية ' + title);
          if (input) input.setAttribute('aria-label', 'كمية ' + title);
        });
      });
    }
    sync();
    new MutationObserver(sync).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Keep a stable return target outside the drawer while its inner HTML is replaced.
  function localizeCart(drawer) {
    drawer.lang = 'ar';
    drawer.dir = 'rtl';
    var labels = {
      'Your cart': 'سلة التسوق',
      'Your cart is empty': 'سلتك فارغة',
      'Continue shopping': 'متابعة التسوق',
      'Savings': 'التوفير',
      'Subtotal': 'المجموع الفرعي',
      'Total': 'الإجمالي',
      'Check out': 'إتمام الطلب',
      'Cart reserved for': 'الوقت المتبقي للسلة ',
      'Regular price': 'السعر الأصلي',
      'Sale price': 'السعر الحالي',
      'Loading...': 'جارٍ التحديث…'
    };
    var heading = drawer.querySelector('.drawer__heading');
    var count = heading && heading.textContent.trim().match(/^Cart\s*[•·]\s*(\d+)\s*items?$/i);
    if (count) {
      var number = document.createElement('bdi');
      number.dir = 'ltr';
      number.lang = 'en';
      number.textContent = count[1];
      heading.replaceChildren(document.createTextNode('سلة التسوق · '), number);
    }
    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, noscript')) continue;
      var text = node.nodeValue.trim();
      if (labels[text]) node.nodeValue = labels[text];
      else if (/^Decrease quantity for /.test(text)) node.nodeValue = text.replace('Decrease quantity for ', 'تقليل كمية ');
      else if (/^Increase quantity for /.test(text)) node.nodeValue = text.replace('Increase quantity for ', 'زيادة كمية ');
    }
    all(drawer, '.cart-drawer-item__saving strong').forEach(function (el) {
      var match = el.textContent.trim().match(/^\(You save (.+)\)$/);
      if (!match) return;
      var amount = document.createElement('bdi');
      amount.dir = 'ltr';
      amount.lang = 'en';
      amount.textContent = match[1];
      el.replaceChildren(document.createTextNode('وفّرت '), amount);
    });
    all(drawer, '[aria-label]').forEach(function (el) {
      var label = el.getAttribute('aria-label');
      if (label === 'Close') el.setAttribute('aria-label', 'إغلاق السلة');
      else if (labels[label]) el.setAttribute('aria-label', labels[label]);
      else if (/^Remove /.test(label)) el.setAttribute('aria-label', label.replace('Remove ', 'إزالة '));
    });
    all(drawer, '.price--end, .cart-drawer__totals__row__money, countdown-timer').forEach(function (el) {
      el.dir = 'ltr';
      el.lang = 'en';
    });
    all(drawer, '.cart-drawer__totals__row').forEach(function (row) {
      var value = row.lastElementChild;
      if (value && value.querySelector('.cart-drawer__totals__row__money')) {
        value.dir = 'ltr';
        value.lang = 'en';
      }
    });
  }

  function initCartAccessibility() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.eikAccessible) return;
    drawer.dataset.eikAccessible = '1';
    var returnTarget = document.querySelector('.header__icon--cart');
    var wasOpen = drawer.classList.contains('active');
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.header__icon--cart, .iqe [data-add]');
      if (trigger && !drawer.contains(trigger)) returnTarget = trigger;
    }, true);
    function usable(el) {
      return el && el.isConnected && !el.closest('[inert]') && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    }
    function sync() {
      localizeCart(drawer);
      var open = drawer.classList.contains('active');
      drawer.inert = !open;
      if (open && (!wasOpen || !drawer.contains(document.activeElement))) {
        if (!wasOpen && usable(returnTarget) && drawer.setActiveElement) drawer.setActiveElement(returnTarget);
        requestAnimationFrame(function () {
          if (!drawer.classList.contains('active') || drawer.contains(document.activeElement)) return;
          var dialog = drawer.querySelector('[role="dialog"]');
          if (dialog) dialog.focus({ preventScroll: true });
        });
      }
      if (wasOpen && !open) {
        requestAnimationFrame(function () {
          if (drawer.classList.contains('active')) return;
          var target = usable(returnTarget) ? returnTarget : document.querySelector('.header__icon--cart');
          if (usable(target)) target.focus({ preventScroll: true });
        });
      }
      wasOpen = open;
    }
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    sync();
  }

  function init(scope) {
    scope = scope || document;
    initLanguage(scope);
    scope.querySelectorAll('[data-eik-cfg]').forEach(initWardrobe);
    scope.querySelectorAll('[data-eik-video-card]').forEach(initVideo);
    scope.querySelectorAll('[data-eik-scene="interact"], [data-eik-scene="expressions"]').forEach(function (scene) {
      deferWhenNear(scene, 'img[data-eiliko-src]');
    });
    scope.querySelectorAll('section[id^="MainProduct-"], .eik, .eiliko-sticky').forEach(watchDigits);
  }

  function boot() {
    init(document);
    initSticky();
    initSteppers();
    initBundleAccessibility();
    initCartAccessibility();
    initBundleMotion();
    document.addEventListener('click', onPick);
  }

  window.EilikoPage = { init: init, normaliseDigits: normaliseDigits, syncSteppers: syncSteppers };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
